import { useQuery } from '@tanstack/react-query';
import { Package } from 'lucide-react';
import { fileObjectUrl } from '../../../lib/api';
import { cx } from '../../../components/ui';

/** Product picture, fetched once through the authorised file route and cached. */
export function Thumb({ fileId, size = 40, className }: { fileId?: string | null; size?: number; className?: string }) {
  const q = useQuery({
    queryKey: ['crm', 'catalog', 'image', fileId],
    queryFn: () => fileObjectUrl(fileId!),
    enabled: Boolean(fileId),
    staleTime: Infinity, gcTime: 30 * 60_000, retry: false,
  });
  return (
    <div style={{ width: size, height: size }}
      className={cx('flex shrink-0 items-center justify-center overflow-hidden rounded-lg bg-ink-100 text-ink-400', className)}>
      {q.data
        ? <img src={q.data} alt="" loading="lazy" className="h-full w-full object-cover" />
        : <Package style={{ width: size * 0.45, height: size * 0.45 }} aria-hidden />}
    </div>
  );
}
